import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useMemo, useCallback } from 'react';
import { PlaybackTime } from './ui/PlaybackTime.js';
import { ProgressBar } from './ui/ProgressBar.js';
import TextButton from './ui/TextButton.js';
import Icon, { IconTypes, IconColors } from './ui/Icon.js';
import { b as LabelColors, L as Label, a as LabelTypography } from './index-6420013c.js';
import { u as useLocalization } from './LocalizationContext-a82461b5.js';
import { i as VOICE_RECORDER_CLICK_BUFFER_TIME, a as VOICE_RECORDER_DEFAULT_MIN } from './consts-fa6ab3c0.js';

/* eslint-disable no-redeclare */
var VoiceMessageInputStatus = {
  READY_TO_RECORD: 'READY_TO_RECORD',
  RECORDING: 'RECORDING',
  READY_TO_PLAY: 'READY_TO_PLAY',
  PLAYING: 'PLAYING'
};
var ControlerIcon = function ControlerIcon(_ref) {
  var inputState = _ref.inputState;
  switch (inputState) {
    case VoiceMessageInputStatus.READY_TO_RECORD:
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "sendbird-controler-icon record-icon"
        });
      }
    case VoiceMessageInputStatus.RECORDING:
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "sendbird-controler-icon stop-icon"
        });
      }
    case VoiceMessageInputStatus.READY_TO_PLAY:
      {
        return /*#__PURE__*/React__default.createElement(Icon, {
          className: "sendbird-controler-icon play-icon",
          width: "20px",
          height: "20px",
          type: IconTypes.PLAY,
          fillColor: IconColors.ON_BACKGROUND_1
        });
      }
    case VoiceMessageInputStatus.PLAYING:
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "sendbird-controler-icon pause-icon"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "sendbird-controler-icon pause-icon-inner"
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "sendbird-controler-icon pause-icon-inner"
        }));
      }
    default:
      return null;
  }
};
var VoiceMessageInput = function VoiceMessageInput(_ref) {
  var _ref$minRecordTime = _ref.minRecordTime,
    minRecordTime = _ref$minRecordTime === void 0 ? VOICE_RECORDER_DEFAULT_MIN : _ref$minRecordTime,
    maximumValue = _ref.maximumValue,
    _ref$currentValue = _ref.currentValue,
    currentValue = _ref$currentValue === void 0 ? 0 : _ref$currentValue,
    currentType = _ref.currentType,
    onCancelClick = _ref.onCancelClick,
    onControlClick = _ref.onControlClick,
    onSubmitClick = _ref.onSubmitClick,
    renderCancelButton = _ref.renderCancelButton,
    renderControlButton = _ref.renderControlButton,
    renderSubmitButton = _ref.renderSubmitButton;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    lastClickTime = _useState2[0],
    setLastClickTime = _useState2[1];
  var isReadyToRecord = useMemo(function () {
    return currentType === VoiceMessageInputStatus.READY_TO_RECORD;
  }, [currentType]);
  var isRecording = useMemo(function () {
    return currentType === VoiceMessageInputStatus.RECORDING;
  }, [currentType]);
  var isSendButtonDisabled = useMemo(function () {
    if (currentType === VoiceMessageInputStatus.READY_TO_RECORD || currentType === VoiceMessageInputStatus.RECORDING) {
      return minRecordTime > currentValue;
    }
    return false;
  }, [currentType, minRecordTime, currentValue]);
  var isPlayMode = useMemo(function () {
    return currentType === VoiceMessageInputStatus.READY_TO_PLAY || currentType === VoiceMessageInputStatus.PLAYING;
  }, [currentType]);
  var _useLocalization = useLocalization(),
    stringSet = _useLocalization.stringSet;
  var handleOnCancelClick = function handleOnCancelClick() {
    var currentTime = Date.now();
    if (currentTime - lastClickTime > VOICE_RECORDER_CLICK_BUFFER_TIME) {
      onCancelClick();
      setLastClickTime(currentTime);
    }
  };
  var handleOnControlClick = useCallback(function () {
    var currentTime = Date.now();
    if (currentTime - lastClickTime > VOICE_RECORDER_CLICK_BUFFER_TIME) {
      onControlClick(currentType);
      setLastClickTime(currentTime);
    }
  }, [currentType]);
  var handleOnSubmitClick = function handleOnSubmitClick() {
    var currentTime = Date.now();
    if (currentTime - lastClickTime > VOICE_RECORDER_CLICK_BUFFER_TIME) {
      if (!isSendButtonDisabled) {
        onSubmitClick();
      }
      setLastClickTime(currentTime);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input__indicator"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input__indicator__progress-bar"
  }, /*#__PURE__*/React__default.createElement(ProgressBar, {
    className: "sendbird-voice-message-input__indicator__progress-bar__bar",
    disabled: isReadyToRecord,
    maxSize: maximumValue,
    currentSize: currentValue
  })), isRecording ? /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input__indicator__on-rec"
  }) : null, /*#__PURE__*/React__default.createElement(PlaybackTime, {
    className: "sendbird-voice-message-input__indicator__playback-time",
    time: isPlayMode ? maximumValue - currentValue : currentValue,
    labelColor: isReadyToRecord ? LabelColors.ONBACKGROUND_4 : LabelColors.ONCONTENT_1
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input__controler"
  }, (renderCancelButton === null || renderCancelButton === void 0 ? void 0 : renderCancelButton()) || /*#__PURE__*/React__default.createElement(TextButton, {
    className: "sendbird-voice-message-input__controler__cancel",
    onClick: handleOnCancelClick,
    disableUnderline: true
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.BUTTON_1,
    color: LabelColors.PRIMARY
  }, stringSet.BUTTON__CANCEL)), (renderControlButton === null || renderControlButton === void 0 ? void 0 : renderControlButton(currentType)) || /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input__controler__main",
    onClick: handleOnControlClick
  }, /*#__PURE__*/React__default.createElement(ControlerIcon, {
    inputState: currentType
  })), (renderSubmitButton === null || renderSubmitButton === void 0 ? void 0 : renderSubmitButton()) || /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-voice-message-input__controler__submit ".concat(isSendButtonDisabled ? 'voice-message--disabled' : ''),
    onClick: handleOnSubmitClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    width: "19px",
    height: "19px",
    type: IconTypes.SEND,
    fillColor: isSendButtonDisabled ? IconColors.ON_BACKGROUND_4 : IconColors.CONTENT
  }))));
};
export { VoiceMessageInputStatus as V, VoiceMessageInput as a };